import { render, staticRenderFns } from "./SampleOrderCart.vue?vue&type=template&id=0ca08f62&scoped=true"
import script from "./SampleOrderCart.vue?vue&type=script&lang=ts"
export * from "./SampleOrderCart.vue?vue&type=script&lang=ts"
import style0 from "./SampleOrderCart.vue?vue&type=style&index=0&id=0ca08f62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca08f62",
  null
  
)

export default component.exports